import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store/index"
import VeeValidate, { Validator } from "vee-validate"
import sl from "vee-validate/dist/locale/sl"
import { mapActions, mapGetters } from "vuex"
import Notify from "vue2-notify"

/**
 * Importing UiKit from same project
 * on real environment call it like this:
 * import UiKit from '@hudlab/ui-kit'
 *
 */
import UiKit from "./../../../ui-kit"

/**
 * Also keep in mind that you have to load
 * scss files -> index.scss (check App.vue)
 */

Vue.config.productionTip = false

Vue.use(VeeValidate)
Validator.localize("sl", sl)

Vue.use(UiKit)

/**
 * Notify - notifications
 */
Vue.use(Notify, {
  itemClass: "notification",
  position: "bottom-right"
})
const types = {
  info: { itemClass: "notification--info" },
  error: { itemClass: "notification--error" },
  warning: { itemClass: "notification--warning" },
  success: { itemClass: "notification--success" }
}
Vue.$notify.setTypes(types)

new Vue({
  router,
  store,
  created () {
    // Global Ui
    Vue.prototype.$getUi = this.getUi
    Vue.prototype.$setUi = this.setUi
    Vue.prototype.$removeUi = this.removeUi
  },
  methods: {
    ...mapActions({
      setUi: "layout/setUi",
      removeUi: "layout/removeUi"
    }),
    ...mapGetters({ getUi: "layout/getUi" })
  },
  render: h => h(App)
}).$mount("#app")
